import { useRequest } from 'ahooks'
import { Button, Descriptions, Space, Spin } from 'antd'
import { useTheme } from 'antd-style'

import { auditAuctionHaltApi } from '@eastcoal/api/trade/auctionOperation/auditAuctionHalt'
import { queryAuctionHaltApi } from '@eastcoal/api/trade/auctionOperation/queryAuctionHalt'

import { ThrottleButton } from '@eastcoal/common/components/Button/ThrottleButton'
import { DataError } from '@eastcoal/common/components/DataError'
import { DraggableModal } from '@eastcoal/common/components/DraggableModal'
import { UploadFile } from '@eastcoal/common/components/UploadFile'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { useAuctionListStore } from '../../../Store/hooks/useStore'

export const AuctionHaltFormModal = () => {
  const { tableRef, currentAuction, haltFormVisible, toggleHaltFormVisible } =
    useAuctionListStore(state =>
      pick(state, [
        'tableRef',
        'currentAuction',
        'haltFormVisible',
        'toggleHaltFormVisible'
      ])
    )

  const auctionId = currentAuction?.id

  const { data, loading, error, refreshAsync } = useRequest(
    () => queryAuctionHaltApi({ id: auctionId }),
    {
      manual: false,
      ready: haltFormVisible
    }
  )

  const title = `${currentAuction?.title}-终止竞价`
  const ossIds = data?.ossIds?.split(',')

  const body = (
    <Spin spinning={loading}>
      <DataError error={error} reload={refreshAsync} />
      <Descriptions
        bordered
        column={1}
        items={[
          {
            label: '申请时间',
            children: data?.createdTime
          },
          {
            label: '终止原因',
            children: data?.reason
          },
          {
            label: '附件',
            children: <UploadFile readPretty value={ossIds} />
          }
        ]}
      />
    </Spin>
  )

  const { message } = useFeedback()

  const { loading: submitLoading, runAsync } = useRequest(auditAuctionHaltApi, {
    manual: true,
    onSuccess() {
      tableRef.current?.reload()
    }
  })

  const closeModal = () => {
    toggleHaltFormVisible(false)
  }

  const handleReject = async () => {
    await runAsync({
      auctionId: currentAuction?.id,
      successful: false
    })
    closeModal()
    message.success('竞价终止已拒绝')
  }

  const handleResolve = async () => {
    await runAsync({
      auctionId: currentAuction?.id,
      successful: true
    })
    closeModal()
    message.success('竞价终止已同意')
  }

  const footer = (
    <Space>
      <Button type='default' onClick={closeModal}>
        取消
      </Button>
      <ThrottleButton
        danger
        loading={submitLoading}
        type='primary'
        onClick={handleReject}
      >
        拒绝
      </ThrottleButton>
      <ThrottleButton
        loading={submitLoading}
        type='primary'
        onClick={handleResolve}
      >
        同意
      </ThrottleButton>
    </Space>
  )

  const theme = useTheme()

  return (
    <DraggableModal
      footer={footer}
      open={haltFormVisible}
      title={title}
      width={640}
      styles={{
        body: {
          paddingBlock: theme.paddingXS
        }
      }}
      onOpenChange={toggleHaltFormVisible}
    >
      {body}
    </DraggableModal>
  )
}
